"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _index = _interopRequireDefault(require("../../renderings/JssForm/index"));
var _LeadFormData = require("./LeadFormData");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *  A react component to display confirmation modal on calendly link click
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.show show or hide modal
 * @param {object} props.navigateLink link to open when click on continue
 * @param {object} props.onModelClose execute function on close of modal and link click
 *
 * @returns {React.ReactElement} calendly confirmation modal
 */
function LeadFormModal(props) {
  if (props && props.data && props.formData) {
    (0, _LeadFormData.setFinproLeadFormData)({
      agentId: props.data.agentId,
      coreAgencyNumber: props.data.coreAgencyNumber,
      subAgencyNumber: props.data.subAgencyNumber,
      agencyName: props.data.agencyName
    });
    return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
      size: "md",
      show: props.show,
      onHide: props.onModelClose,
      centered: true,
      contentClassName: 'default',
      title: 'LeadForm',
      id: 'modal-lead'
    }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
      title: props.data.modalTitle,
      onClose: () => props.onModelClose()
    }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(_index.default, {
      renderings: props.formData,
      fields: props.formData.fields,
      params: props.formData.params
    })));
  } else return null;
}
var _default = exports.default = LeadFormModal;